import { render, staticRenderFns } from "./UnidadeSaudeIcon.vue?vue&type=template&id=34319261"
import script from "./UnidadeSaudeIcon.vue?vue&type=script&lang=js"
export * from "./UnidadeSaudeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports